import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';
import { ApiMessage, ApiMessageType, ApiResponseMessages } from '../models/global.model';
import { ToasterMessageType } from './pseic-toaster-ref';
import { PseicToasterService } from './pseic-toaster.service';

@Injectable({
  providedIn: 'root'
})
export class PpbToasterService {

  private static toToasterMessageType(type: ApiMessageType): ToasterMessageType {
    if (type === 'INFO') {
      return 'message';
    }
    return type.toLowerCase() as ToasterMessageType;
  }

  private readonly DEFAULT_DELAY = 2500;

  constructor(private toaster: PseicToasterService) {
  }

  openFor(apiResponseMessages: ApiResponseMessages, delayBetweenMessages: number = this.DEFAULT_DELAY): boolean {
    let messageShown = false;
    if (apiResponseMessages && apiResponseMessages.messages && apiResponseMessages.messages.length > 0) {
      const printableMessages = apiResponseMessages.messages.filter(message => message.printable);
      if (printableMessages.length > 0) {
        messageShown = true;
        of(...printableMessages).pipe(
          concatMap((message: ApiMessage) => {
            const delay = message.description === printableMessages[0].description ? 0 : delayBetweenMessages;
            return this.showWithDelay(message, delay)
          })
        ).subscribe(_ => _);
      }
    }
    return messageShown;
  }

  open(message: string, messageType: ToasterMessageType = 'message', autoClose: boolean = true): OverlayRef {
    return this.toaster.open(message, messageType, autoClose);
  }

  private showWithDelay(message: ApiMessage, timeout: number): Observable<void> {
    return timer(timeout).pipe(map(_ => this.show(message)));
  }

  private show(printableMessage: ApiMessage): void {
    const toasterMessageType = PpbToasterService.toToasterMessageType(printableMessage.type);
    this.toaster.open(printableMessage.description, toasterMessageType);
  }
}
